// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___30nUm","title":"title___2HIAt","desc":"desc___3MSkt","btn":"btn___1js-B"};